<template>
  <vs-card>
    <div class="p-6 rounded-md">
      <div class="mb-6">
        <div class="mb-4 flex gap-4 items-center">
          <h4 class="text-xl font-semibold">{{ currentRecord ? 'Edit' : 'Create' }} New Letter</h4>
          <!-- <vs-button color="success" @click="addNewLetter">Add New Letter</vs-button> -->
        </div>

        <div v-for="(letter, index) in letters" :key="index" class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 border p-4 rounded-lg relative">
          <!-- Remove Letter Button -->
          <vs-button icon="delete" color="danger" size="small" class="absolute top-0 right-0 m-2" @click="removeLetter(index)" v-if="letters.length > 1"></vs-button>

          <!-- Punjabi Letter -->
          <div class="w-full">
            <div class="flex mb-2 gap-2">
              <strong>Punjabi Letter *</strong>
            </div>
            <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
              <textarea
                v-model="letter.punjabi_letter"
                v-validate="'required|exclude_special_char'"
                :name="'punjabi_letter_' + index"
                class="w-full input mb-0 vs-textarea"
                rows="3"
                placeholder="ਸ਼"
              ></textarea>
            </div>
            <span class="text-danger text-sm" v-if="errors.has('punjabi_letter_' + index)">
              {{ errors.first('punjabi_letter_' + index) }}
            </span>
          </div>

          <!-- English Pronounce -->
          <div class="w-full">
            <div class="flex mb-2 gap-2">
              <strong>English Pronounce</strong>
            </div>
            <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
              <textarea
                v-model="letter.english_pronounce"
                v-validate="'exclude_special_char'"
                :name="'english_pronounce_' + index"
                class="w-full input mb-0 vs-textarea"
                rows="3"
                placeholder="Sh"
              ></textarea>
            </div>
            <span class="text-danger text-sm" v-if="errors.has('english_pronounce_' + index)">
              {{ errors.first('english_pronounce_' + index) }}
            </span>
          </div>

          <!-- English Letter -->
          <div class="w-full">
            <div class="flex mb-2 gap-2">
              <strong>English Letter</strong>
            </div>
            <div class="vs-component vs-con-textarea w-full input mb-0 vs-textarea-primary">
              <textarea v-model="letter.english_letter" v-validate="'exclude_special_char'" :name="'english_letter_' + index" class="w-full input mb-0 vs-textarea" rows="3" placeholder="S"></textarea>
            </div>
            <span class="text-danger text-sm" v-if="errors.has('english_letter_' + index)">
              {{ errors.first('english_letter_' + index) }}
            </span>
          </div>

          <!-- Audio Recording -->
          <div class="w-full">
            <div class="flex mb-2 gap-2">
              <strong>Sound Recording</strong>
            </div>
            <div class="audio-controls flex gap-2 items-center">
              <!-- Mic button -->
              <vs-button v-if="!letter.isRecording && !letter.audio" icon="mic" color="primary" class="rounded-full audio-button" @click="startRecording(index)"></vs-button>

              <!-- Complete button with timer -->
              <div v-if="letter.isRecording" class="flex items-center gap-2">
                <vs-button icon="stop" color="danger" class="rounded-full audio-button" @click="stopRecording(index)"> </vs-button>
                <span class="font-semibold">{{ letter.timer }} sec</span>
              </div>

              <!-- Audio controls and delete -->
              <div v-if="letter.audio" class="flex gap-2 items-center">
                <audio :src="letter.audio" controls class="mt-2"></audio>
                <vs-button icon="delete" color="danger" class="rounded-full audio-button" @click="deleteAudio(index)"></vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-divider class="my-4"></vs-divider>

      <div class="flex justify-end gap-4 mt-6">
        <vs-button color="danger" @click="resetForm">Cancel</vs-button>
        <vs-button class="mr-2 vs-con-loading__container" id="create-letter" color="primary" @click="submitForm">Save Letters</vs-button>
      </div>
    </div>
  </vs-card>
</template>

<script>
import RecordRTC from 'recordrtc'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'LetterList',
  data() {
    return {
      letters: [
        {
          punjabi_letter: '',
          english_pronounce: '',
          english_letter: '',
          audio: null,
          audioBlob: null, // Store the actual blob for submission
          isRecording: false,
          timer: 0,
          timerInterval: null
        }
      ],
      currentRecord: this.$route.params.id,
      recorder: null,
      currentRecordingIndex: null,
      stream: null
    }
  },

  /** computed */
  computed: {
    ...mapState('learningMode', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    ...mapActions('learningMode', {
      create: 'create',
      update: 'update'
    }),

    addNewLetter() {
      this.letters.push({
        punjabi_letter: '',
        english_pronounce: '',
        english_letter: '',
        audio: null,
        audioBlob: null,
        isRecording: false,
        timer: 0,
        timerInterval: null
      })
    },
    removeLetter(index) {
      if (this.letters.length > 1) {
        this.letters.splice(index, 1)
      }
    },
    async startRecording(index) {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.recorder = RecordRTC(this.stream, {
          type: 'audio',
          mimeType: 'audio/mp3',
          recorderType: RecordRTC.StereoAudioRecorder,
          numberOfAudioChannels: 1,
          desiredSampRate: 16000
        })
        this.currentRecordingIndex = index
        this.recorder.startRecording()
        this.$set(this.letters[index], 'isRecording', true)
        this.startTimer(index)
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Could not access microphone. Please check permissions.',
          color: 'danger',
          position: 'top-center'
        })
      }
    },
    stopRecording(index) {
      if (this.recorder) {
        this.recorder.stopRecording(() => {
          const audioBlob = this.recorder.getBlob()
          const audioURL = URL.createObjectURL(audioBlob)

          // Store both URL for preview and blob for submission
          this.$set(this.letters[index], 'audio', audioURL)
          this.$set(this.letters[index], 'audioBlob', audioBlob)
          this.$set(this.letters[index], 'isRecording', false)
          this.stopTimer(index)
          if (this.stream) {
            this.stream.getTracks().forEach((track) => track.stop())
          }
        })
      }
    },
    deleteAudio(index) {
      this.$set(this.letters[index], 'audio', null)
      this.$set(this.letters[index], 'audioBlob', null)
      this.$set(this.letters[index], 'timer', 0)
    },
    startTimer(index) {
      this.letters[index].timer = 0
      this.letters[index].timerInterval = setInterval(() => {
        this.letters[index].timer += 1
      }, 1000)
    },
    stopTimer(index) {
      clearInterval(this.letters[index].timerInterval)
      this.letters[index].timerInterval = null
    },
    resetForm() {
      this.letters = [
        {
          punjabi_letter: '',
          english_pronounce: '',
          english_letter: '',
          audio: null,
          audioBlob: null,
          isRecording: false,
          timer: 0,
          timerInterval: null
        }
      ]
      this.$router.push(`/punjabi-letter/list`)
    },

    // Prepare single letter object for submission matching backend expectations
    prepareLetterData(letter) {
      const formData = new FormData()

      // Add form fields directly (not as JSON object)
      formData.append('punjabi_letter', letter.punjabi_letter || '')
      formData.append('english_pronounce', letter.english_pronounce || '')
      formData.append('english_letter', letter.english_letter || '')

      // Add audio file if exists (backend expects 'file' field)
      if (letter.audioBlob) {
        formData.append('audio', letter.audioBlob, 'letter_audio.mp3')
      }

      return formData
    },

    // Alternative: Send single letter as JSON object (if needed)
    async prepareLetterJSONData(letter) {
      const letterData = {
        punjabi_letter: letter.punjabi_letter || '',
        english_pronounce: letter.english_pronounce || '',
        english_letter: letter.english_letter || '',
        audio_data: letter.audioBlob ? await this.blobToBase64(letter.audioBlob) : null
      }

      return letterData
    },

    // Helper function to convert blob to base64
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },

    async submitForm() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            let successCount = 0
            let errorCount = 0
            let response

            // Process each letter one by one
            for (let i = 0; i < this.letters.length; i++) {
              const letter = this.letters[i]

              try {
                const formData = this.prepareLetterData(letter)
                if (this.currentRecord) {
                  const id = this.currentRecord
                  response = await this.update({
                    learningModeId: id,
                    data: formData
                  })

                  this.$vs.notify({
                    title: 'Success',
                    text: response.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    position: 'top-center',
                    time: 5000,
                    color: 'success'
                  })
                } else {
                  response = await this.create(formData)

                  successCount++
                }
                this.$router.push(`/punjabi-letter/list`)
              } catch (error) {
                console.error(`Error submitting letter ${i + 1}:`, error)
                errorCount++
              }
            }

            // Show final result
            // if (successCount === this.letters.length) {
            //   this.$vs.notify({
            //     title: 'Success',
            //     text: `All ${successCount} letters saved successfully!`,
            //     iconPack: 'feather',
            //     icon: 'icon-alert-circle',
            //     position: 'top-center',
            //     time: 5000,
            //     color: 'success'
            //   })

            //   // Reset form after successful submission
            //   this.resetForm()
            // } else {
            //   this.$vs.notify({
            //     title: 'Partial Success',
            //     text: `${successCount} letters saved successfully, ${errorCount} failed.`,
            //     iconPack: 'feather',
            //     icon: 'icon-alert-circle',
            //     position: 'top-center',
            //     time: 5000,
            //     color: 'warning'
            //   })
            // }
          } catch (error) {
            console.error('Submission error:', error)
            this.$vs.notify({
              color: 'danger',
              title: 'Submission Error',
              text: 'Failed to save letters. Please try again.'
            })
          }
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Validation Error',
            text: 'Please fix the errors in the form.'
          })
        }
      })
    }
  },

  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('learningMode/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data.learningMode

        this.letters[0].punjabi_letter = data.punjabi_letter
        this.letters[0].english_pronounce = data.english_pronounce
        this.letters[0].english_letter = data.english_letter
        this.letters[0].audio = data.audio_recording
      })
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-letter',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-letter > .con-vs-loading')
      }
    }
  }
}
</script>

<style scoped>
.audio-button {
  width: 50px;
  height: 50px;
}
</style>
